// extracted by mini-css-extract-plugin
export default {"chatButton":"ChatButton_chatButton__Dg0yl","chat":"ChatButton_chat__qYcqM","chatIconBadge":"ChatButton_chatIconBadge__+etml"};